// @generated by protobuf-ts 2.8.1 with parameter generate_dependencies,long_type_number,ts_nocheck,optimize_code_size
// @generated from protobuf file "c1/api/iam/v1/clients.proto" (package "c1.api.iam.v1", syntax proto3)
// tslint:disable
// @ts-nocheck
import { ServiceType } from "@protobuf-ts/runtime-rpc";
import { MessageType } from "@protobuf-ts/runtime";
import { UserRef } from "../../user/v1/user";
import { Duration } from "../../../../google/protobuf/duration";
import { FieldMask } from "../../../../google/protobuf/field_mask";
import { Timestamp } from "../../../../google/protobuf/timestamp";
/**
 * @generated from protobuf message c1.api.iam.v1.PersonalClientRef
 */
export interface PersonalClientRef {
    /**
     * @generated from protobuf field: string id = 2;
     */
    id: string;
}
/**
 * The PersonalClient message contains information about a presonal client credential.
 *
 * @generated from protobuf message c1.api.iam.v1.PersonalClient
 */
export interface PersonalClient {
    /**
     * The unique ID of the personal client credential.
     *
     * @generated from protobuf field: string id = 1;
     */
    id: string;
    /**
     * The ID of the user that this credential is created for.
     *
     * @generated from protobuf field: string user_id = 2;
     */
    userId: string;
    /**
     * The datetime, in RFC3339 format, of when the PersonalClient was created.
     *
     * @generated from protobuf field: google.protobuf.Timestamp created_at = 3;
     */
    createdAt?: Timestamp;
    /**
     * The datetime, in RFC3339 format, of when the PersonalClient was last updated.
     *
     * @generated from protobuf field: google.protobuf.Timestamp updated_at = 4;
     */
    updatedAt?: Timestamp;
    /**
     * The datetime, in RFC3339 format, of when the PersonalClient was deleted.
     *
     * @generated from protobuf field: google.protobuf.Timestamp deleted_at = 5;
     */
    deletedAt?: Timestamp;
    /**
     * The datetime, in RFC3339 format, of when the PersonalClient was last used.
     *
     * @generated from protobuf field: google.protobuf.Timestamp last_used_at = 6;
     */
    lastUsedAt?: Timestamp;
    /**
     * The datetime, in RFC3339 format, of when the PersonalClient will expire.
     *
     * @generated from protobuf field: google.protobuf.Timestamp expires_time = 7;
     */
    expiresTime?: Timestamp;
    /**
     * The display name of the personal client credential.
     *
     * @generated from protobuf field: string display_name = 8;
     */
    displayName: string;
    /**
     * The clientID of the credential.
     *
     * @generated from protobuf field: string client_id = 9;
     */
    clientId: string;
    /**
     * scoped_roles provides a list of IAM Roles
     * that this OAuth2 Client's API permissions
     * are reduced to. The permissions granted to OAuth2 Client
     * are AND'ed against the owning User's own permissions.
     *
     * @generated from protobuf field: repeated string scoped_roles = 10;
     */
    scopedRoles: string[];
    /**
     * If set, only allows the CIDRs in the array to use the credential.
     *
     * @generated from protobuf field: repeated string allow_source_cidr = 11;
     */
    allowSourceCidr: string[];
}
/**
 * @generated from protobuf message c1.api.iam.v1.PersonalClientServiceGetRequest
 */
export interface PersonalClientServiceGetRequest {
    /**
     * @generated from protobuf field: string id = 1;
     */
    id: string;
}
/**
 * @generated from protobuf message c1.api.iam.v1.PersonalClientServiceGetResponse
 */
export interface PersonalClientServiceGetResponse {
    /**
     * @generated from protobuf field: c1.api.iam.v1.PersonalClient client = 1;
     */
    client?: PersonalClient;
}
/**
 * @generated from protobuf message c1.api.iam.v1.PersonalClientServiceUpdateRequest
 */
export interface PersonalClientServiceUpdateRequest {
    /**
     * @generated from protobuf field: c1.api.iam.v1.PersonalClient client = 1;
     */
    client?: PersonalClient;
    /**
     * @generated from protobuf field: google.protobuf.FieldMask update_mask = 2;
     */
    updateMask?: FieldMask;
}
/**
 * @generated from protobuf message c1.api.iam.v1.PersonalClientServiceUpdateResponse
 */
export interface PersonalClientServiceUpdateResponse {
    /**
     * @generated from protobuf field: c1.api.iam.v1.PersonalClient client = 1;
     */
    client?: PersonalClient;
}
/**
 * @generated from protobuf message c1.api.iam.v1.PersonalClientServiceListRequest
 */
export interface PersonalClientServiceListRequest {
    /**
     * @generated from protobuf field: int32 page_size = 1;
     */
    pageSize: number;
    /**
     * @generated from protobuf field: string page_token = 2;
     */
    pageToken: string;
}
/**
 * @generated from protobuf message c1.api.iam.v1.PersonalClientServiceListResponse
 */
export interface PersonalClientServiceListResponse {
    /**
     * @generated from protobuf field: repeated c1.api.iam.v1.PersonalClient list = 1;
     */
    list: PersonalClient[];
    /**
     * @generated from protobuf field: string next_page_token = 2;
     */
    nextPageToken: string;
}
/**
 * @generated from protobuf message c1.api.iam.v1.PersonalClientServiceDeleteRequest
 */
export interface PersonalClientServiceDeleteRequest {
    /**
     * @generated from protobuf field: string id = 1;
     */
    id: string;
}
/**
 * @generated from protobuf message c1.api.iam.v1.PersonalClientServiceDeleteResponse
 */
export interface PersonalClientServiceDeleteResponse {
}
/**
 * The PersonalClientServiceCreateRequest message contains the fields for creating a new personal client.
 *
 * @generated from protobuf message c1.api.iam.v1.PersonalClientServiceCreateRequest
 */
export interface PersonalClientServiceCreateRequest {
    /**
     * The display name for the new personal client.
     *
     * @generated from protobuf field: string display_name = 1;
     */
    displayName: string;
    /**
     * The list of roles to restrict the credential to.
     *
     * @generated from protobuf field: repeated string scoped_roles = 2;
     */
    scopedRoles: string[];
    /**
     * An RFC3339 timestamp for when the credential should expire.
     *
     * @generated from protobuf field: google.protobuf.Duration expires = 3;
     */
    expires?: Duration;
    /**
     * A list of CIDRs to restrict this credential to.
     *
     * @generated from protobuf field: repeated string allow_source_cidr = 4;
     */
    allowSourceCidr: string[];
}
/**
 * The PersonalClientServiceCreateResponse message contains the created personal client and client secret.
 *
 * @generated from protobuf message c1.api.iam.v1.PersonalClientServiceCreateResponse
 */
export interface PersonalClientServiceCreateResponse {
    /**
     * Create a personal client credential with the config.
     *
     * @generated from protobuf field: c1.api.iam.v1.PersonalClient client = 1;
     */
    client?: PersonalClient;
    /**
     * The client secret that corresponds to the personal client. Make sure to save this, because it cannot be returned or queried again.
     *
     * @generated from protobuf field: string client_secret = 2;
     */
    clientSecret: string;
}
/**
 * @generated from protobuf message c1.api.iam.v1.PersonalClientServiceRotateSecretRequest
 */
export interface PersonalClientServiceRotateSecretRequest {
    /**
     * @generated from protobuf field: string id = 1;
     */
    id: string;
}
/**
 * @generated from protobuf message c1.api.iam.v1.PersonalClientServiceRotateSecretResponse
 */
export interface PersonalClientServiceRotateSecretResponse {
    /**
     * @generated from protobuf field: string client_secret = 1;
     */
    clientSecret: string;
}
/**
 * @generated from protobuf message c1.api.iam.v1.PersonalClientSearchServiceSearchRequest
 */
export interface PersonalClientSearchServiceSearchRequest {
    /**
     * @generated from protobuf field: int32 page_size = 1;
     */
    pageSize: number;
    /**
     * @generated from protobuf field: string page_token = 2;
     */
    pageToken: string;
    /**
     * @generated from protobuf field: string query = 3;
     */
    query: string;
    /**
     * @generated from protobuf field: repeated c1.api.user.v1.UserRef users = 4;
     */
    users: UserRef[];
}
/**
 * @generated from protobuf message c1.api.iam.v1.PersonalClientSearchServiceSearchResponse
 */
export interface PersonalClientSearchServiceSearchResponse {
    /**
     * @generated from protobuf field: repeated c1.api.iam.v1.PersonalClient list = 1;
     */
    list: PersonalClient[];
    /**
     * @generated from protobuf field: string next_page_token = 2;
     */
    nextPageToken: string;
}
// @generated message type with reflection information, may provide speed optimized methods
class PersonalClientRef$Type extends MessageType<PersonalClientRef> {
    constructor() {
        super("c1.api.iam.v1.PersonalClientRef", [
            { no: 2, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.iam.v1.PersonalClientRef
 */
export const PersonalClientRef = new PersonalClientRef$Type();
// @generated message type with reflection information, may provide speed optimized methods
class PersonalClient$Type extends MessageType<PersonalClient> {
    constructor() {
        super("c1.api.iam.v1.PersonalClient", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 2, name: "user_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 3, name: "created_at", kind: "message", T: () => Timestamp, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 4, name: "updated_at", kind: "message", T: () => Timestamp, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 5, name: "deleted_at", kind: "message", T: () => Timestamp, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 6, name: "last_used_at", kind: "message", T: () => Timestamp, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 7, name: "expires_time", kind: "message", T: () => Timestamp },
            { no: 8, name: "display_name", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "1", maxBytes: "512" } } } },
            { no: 9, name: "client_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 10, name: "scoped_roles", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32", items: { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } } } },
            { no: 11, name: "allow_source_cidr", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32", items: { string: { pattern: "^([0-9]{1,3}\\.){3}[0-9]{1,3}(\\/([0-9]|[1-2][0-9]|3[0-2]))?$" } } } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.iam.v1.PersonalClient
 */
export const PersonalClient = new PersonalClient$Type();
// @generated message type with reflection information, may provide speed optimized methods
class PersonalClientServiceGetRequest$Type extends MessageType<PersonalClientServiceGetRequest> {
    constructor() {
        super("c1.api.iam.v1.PersonalClientServiceGetRequest", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-z]{3,20}-[a-z]{3,20}-[0-9]{5}$" } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.iam.v1.PersonalClientServiceGetRequest
 */
export const PersonalClientServiceGetRequest = new PersonalClientServiceGetRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class PersonalClientServiceGetResponse$Type extends MessageType<PersonalClientServiceGetResponse> {
    constructor() {
        super("c1.api.iam.v1.PersonalClientServiceGetResponse", [
            { no: 1, name: "client", kind: "message", T: () => PersonalClient }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.iam.v1.PersonalClientServiceGetResponse
 */
export const PersonalClientServiceGetResponse = new PersonalClientServiceGetResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class PersonalClientServiceUpdateRequest$Type extends MessageType<PersonalClientServiceUpdateRequest> {
    constructor() {
        super("c1.api.iam.v1.PersonalClientServiceUpdateRequest", [
            { no: 1, name: "client", kind: "message", T: () => PersonalClient, options: { "validate.rules": { message: { skip: true } } } },
            { no: 2, name: "update_mask", kind: "message", T: () => FieldMask }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.iam.v1.PersonalClientServiceUpdateRequest
 */
export const PersonalClientServiceUpdateRequest = new PersonalClientServiceUpdateRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class PersonalClientServiceUpdateResponse$Type extends MessageType<PersonalClientServiceUpdateResponse> {
    constructor() {
        super("c1.api.iam.v1.PersonalClientServiceUpdateResponse", [
            { no: 1, name: "client", kind: "message", T: () => PersonalClient }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.iam.v1.PersonalClientServiceUpdateResponse
 */
export const PersonalClientServiceUpdateResponse = new PersonalClientServiceUpdateResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class PersonalClientServiceListRequest$Type extends MessageType<PersonalClientServiceListRequest> {
    constructor() {
        super("c1.api.iam.v1.PersonalClientServiceListRequest", [
            { no: 1, name: "page_size", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "validate.rules": { int32: { lte: 100, gte: 0 } } } },
            { no: 2, name: "page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.iam.v1.PersonalClientServiceListRequest
 */
export const PersonalClientServiceListRequest = new PersonalClientServiceListRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class PersonalClientServiceListResponse$Type extends MessageType<PersonalClientServiceListResponse> {
    constructor() {
        super("c1.api.iam.v1.PersonalClientServiceListResponse", [
            { no: 1, name: "list", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => PersonalClient },
            { no: 2, name: "next_page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.iam.v1.PersonalClientServiceListResponse
 */
export const PersonalClientServiceListResponse = new PersonalClientServiceListResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class PersonalClientServiceDeleteRequest$Type extends MessageType<PersonalClientServiceDeleteRequest> {
    constructor() {
        super("c1.api.iam.v1.PersonalClientServiceDeleteRequest", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-z]{3,20}-[a-z]{3,20}-[0-9]{5}$" } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.iam.v1.PersonalClientServiceDeleteRequest
 */
export const PersonalClientServiceDeleteRequest = new PersonalClientServiceDeleteRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class PersonalClientServiceDeleteResponse$Type extends MessageType<PersonalClientServiceDeleteResponse> {
    constructor() {
        super("c1.api.iam.v1.PersonalClientServiceDeleteResponse", []);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.iam.v1.PersonalClientServiceDeleteResponse
 */
export const PersonalClientServiceDeleteResponse = new PersonalClientServiceDeleteResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class PersonalClientServiceCreateRequest$Type extends MessageType<PersonalClientServiceCreateRequest> {
    constructor() {
        super("c1.api.iam.v1.PersonalClientServiceCreateRequest", [
            { no: 1, name: "display_name", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "1", maxBytes: "512" } } } },
            { no: 2, name: "scoped_roles", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32", items: { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } } } },
            { no: 3, name: "expires", kind: "message", T: () => Duration, options: { "validate.rules": { duration: { required: false, lt: { seconds: "63115200" } } } } },
            { no: 4, name: "allow_source_cidr", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32", items: { string: { pattern: "^([0-9]{1,3}\\.){3}[0-9]{1,3}(\\/([0-9]|[1-2][0-9]|3[0-2]))?$" } } } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.iam.v1.PersonalClientServiceCreateRequest
 */
export const PersonalClientServiceCreateRequest = new PersonalClientServiceCreateRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class PersonalClientServiceCreateResponse$Type extends MessageType<PersonalClientServiceCreateResponse> {
    constructor() {
        super("c1.api.iam.v1.PersonalClientServiceCreateResponse", [
            { no: 1, name: "client", kind: "message", T: () => PersonalClient },
            { no: 2, name: "client_secret", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.iam.v1.PersonalClientServiceCreateResponse
 */
export const PersonalClientServiceCreateResponse = new PersonalClientServiceCreateResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class PersonalClientServiceRotateSecretRequest$Type extends MessageType<PersonalClientServiceRotateSecretRequest> {
    constructor() {
        super("c1.api.iam.v1.PersonalClientServiceRotateSecretRequest", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.iam.v1.PersonalClientServiceRotateSecretRequest
 */
export const PersonalClientServiceRotateSecretRequest = new PersonalClientServiceRotateSecretRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class PersonalClientServiceRotateSecretResponse$Type extends MessageType<PersonalClientServiceRotateSecretResponse> {
    constructor() {
        super("c1.api.iam.v1.PersonalClientServiceRotateSecretResponse", [
            { no: 1, name: "client_secret", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.iam.v1.PersonalClientServiceRotateSecretResponse
 */
export const PersonalClientServiceRotateSecretResponse = new PersonalClientServiceRotateSecretResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class PersonalClientSearchServiceSearchRequest$Type extends MessageType<PersonalClientSearchServiceSearchRequest> {
    constructor() {
        super("c1.api.iam.v1.PersonalClientSearchServiceSearchRequest", [
            { no: 1, name: "page_size", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "validate.rules": { int32: { lte: 100, gte: 0 } } } },
            { no: 2, name: "page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } },
            { no: 3, name: "query", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } },
            { no: 4, name: "users", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => UserRef, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32" } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.iam.v1.PersonalClientSearchServiceSearchRequest
 */
export const PersonalClientSearchServiceSearchRequest = new PersonalClientSearchServiceSearchRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class PersonalClientSearchServiceSearchResponse$Type extends MessageType<PersonalClientSearchServiceSearchResponse> {
    constructor() {
        super("c1.api.iam.v1.PersonalClientSearchServiceSearchResponse", [
            { no: 1, name: "list", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => PersonalClient },
            { no: 2, name: "next_page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.iam.v1.PersonalClientSearchServiceSearchResponse
 */
export const PersonalClientSearchServiceSearchResponse = new PersonalClientSearchServiceSearchResponse$Type();
/**
 * @generated ServiceType for protobuf service c1.api.iam.v1.PersonalClientService
 */
export const PersonalClientService = new ServiceType("c1.api.iam.v1.PersonalClientService", [
    { name: "Get", options: { "authz.method": { role: "VIEWER" }, "apigw.v1.method": { operations: [{ method: "GET", route: "/api/v1/iam/personal_clients/{id}", group: "Personal Client" }] } }, I: PersonalClientServiceGetRequest, O: PersonalClientServiceGetResponse },
    { name: "Update", options: { "authz.method": { role: "EDITOR" }, "apigw.v1.method": { operations: [{ method: "POST", route: "/api/v1/iam/personal_clients/{client.id}", group: "Personal Client" }] } }, I: PersonalClientServiceUpdateRequest, O: PersonalClientServiceUpdateResponse },
    { name: "List", options: { "authz.method": { role: "VIEWER" }, "apigw.v1.method": { operations: [{ method: "GET", route: "/api/v1/iam/personal_clients", summary: "NOTE: Only shows personal clients for the current user.", group: "Personal Client" }] } }, I: PersonalClientServiceListRequest, O: PersonalClientServiceListResponse },
    { name: "Delete", options: { "authz.method": { role: "EDITOR" }, "apigw.v1.method": { operations: [{ method: "DELETE", route: "/api/v1/iam/personal_clients/{id}", group: "Personal Client" }] } }, I: PersonalClientServiceDeleteRequest, O: PersonalClientServiceDeleteResponse },
    { name: "Create", options: { "authz.method": { role: "EDITOR" }, "apigw.v1.method": { operations: [{ method: "POST", route: "/api/v1/iam/personal_clients", group: "Personal Client" }] } }, I: PersonalClientServiceCreateRequest, O: PersonalClientServiceCreateResponse }
]);
/**
 * @generated ServiceType for protobuf service c1.api.iam.v1.PersonalClientSearchService
 */
export const PersonalClientSearchService = new ServiceType("c1.api.iam.v1.PersonalClientSearchService", [
    { name: "Search", options: { "authz.method": { role: "VIEWER" }, "apigw.v1.method": { operations: [{ method: "POST", route: "/api/v1/search/iam/personal_clients", summary: "NOTE: Searches personal clients for all users", group: "Personal Client" }] } }, I: PersonalClientSearchServiceSearchRequest, O: PersonalClientSearchServiceSearchResponse }
]);
